import http from '@/biz/http.mjs'

export default {

    publish: (data) => http.put(
        '/archbas/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    pull: ({pkid}) => http.get(`/archbas/${pkid}/dps`),
    push: (data) => http.post('/archbas/batchmodify', data),
    read: ({pkid}) => http.get(`/archbas/${pkid}`),

    revise: ({pkid}) => http.put(
        '/archbas/rlsandrevise',
        {pkid, stsCode: 'REVISE'}
    ),

    update: (data) => http.put(`/archbas/${data.pkid}`, data),
    updateMap: (data) => http.put(`/archbas/${data.pkid}/map`, data),
}
